import { Hero } from "../components/Hero";
import { CapShowcase } from "../components/CapShowcase";
import { CaboSection } from "../components/CaboSection";
import { MindsetSection } from "../components/MindsetSection";
import { Community } from "../components/Community";
import { Newsletter } from "../components/Newsletter";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <CapShowcase />
      <CaboSection />
      <MindsetSection />
      <Community />
      <Newsletter />
    </main>
  );
}
